import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import { Alert, AlertProps, Col, Container, Row } from "react-bootstrap";
import useDownloadCaseAttachment from "../../../../modules/filestore/hooks/useDownloadCaseAttachment";
import { EUFinanceCaseAttachment } from "../../../../modules/filestore/models/sobjects/EUFinanceCaseAttachment";
import { openFileInCurrentTab } from "../../../../modules/filestore/utils/FileUtil";

const CLASSNAME =
  "eu-finance-case-attachment-downloader__case-attachment-downloader";

export type CaseAttachmentDownloaderProps = {
  caseAttachment: EUFinanceCaseAttachment;
};

const CaseAttachmentDownloader: FC<CaseAttachmentDownloaderProps> = ({
  caseAttachment,
}) => {
  const [alertVariant, setAlertVariant] =
    useState<AlertProps["variant"]>("info");
  const [alertBody, setAlertBody] = useState<ReactNode>();

  const onError = useCallback((message: ReactNode) => {
    setAlertVariant("danger");
    setAlertBody(message);
  }, []);

  const onDownloadStart = useCallback((message: ReactNode) => {
    setAlertVariant("info");
    setAlertBody(message);
  }, []);

  const onDownloadComplete = useCallback((message: ReactNode) => {
    setAlertVariant("success");
    setAlertBody(message);
  }, []);

  const { downloadFile: downloadCaseAttachment } = useDownloadCaseAttachment({
    openFile: openFileInCurrentTab,
    onError,
    onDownloadStart,
    onDownloadComplete,
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (caseAttachment.id && downloadCaseAttachment) {
      downloadCaseAttachment(caseAttachment).finally(() => setIsLoading(false));
    }
  }, [caseAttachment, downloadCaseAttachment]);

  if (isLoading) {
    return (
      <div
        className={`${CLASSNAME}__loading d-flex justify-content-center align-items-center`}
      >
        <FontAwesomeIcon icon={faSpinner} spin size="10x" />
      </div>
    );
  }

  return (
    <div className={CLASSNAME}>
      <Container fluid>
        <Row>
          <Col className="mt-3">
            <Alert variant={alertVariant}>
              {alertBody ?? (
                <>
                  Downloading <b>{caseAttachment?.fileName}</b>...
                </>
              )}
            </Alert>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CaseAttachmentDownloader;
